import React, { useEffect, useState } from "react";
import { Container, Alert } from "@mui/joy";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FilterHeader from "../components/FilterHeader";
import LeadCard from "../components/LeadCard";
import { subDays } from "date-fns";

axios.defaults.withCredentials = true;

const BASE_URL = process.env.REACT_APP_BASE_URL;

const LeadsListPage = () => {
  const [leads, setLeads] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    project: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [agentlist, setagentlist] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${BASE_URL}/projectdetails/project/56/agents`, {
        withCredentials: true,
      })
      .then((response) => {
        setagentlist(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/projectdetails/user/projects`
      );
      if (response.data) {
        const formattedProjects = [
          { id: 0, name: "All Projects" },
          ...response.data.map((project) => ({
            id: project.id,
            name: project.project_name,
          })),
        ];
        setProjects(formattedProjects);
      }
    } catch (error) {
      setError("Failed to fetch projects");
      console.error("Error fetching projects:", error);
    }
  };

  const fetchLeads = async (filters = filterOptions) => {
    setIsLoading(true);
    try {
      try {
        // const response = await axios.post(`${BASE_URL}/leads/leads-list`);
        // const payload = {
        //   startDate: "2025-02-07 17:29:46",
        //   endDate: new Date(),
        //   project_ids:[0],
        // };
        const response = await axios.get(
          `${BASE_URL}/leads/user/leads`,
          // payload,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response.data.data);
        setLeads(response.data.data);
        if (response.data?.list) {
          setLeads(response.data);
          // if (response.data.length === 0) {
           
          // }
        }
      } catch (error) {
        console.error("Error fetching leads:", error);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
    fetchLeads();
  }, []);

  const handleDateChange = (newFilter) => {
    setFilterOptions(newFilter);
  };

  const handleProjectChange = (projectId) => {
    setFilterOptions((prev) => ({ ...prev, project: projectId }));
  };

  const handleFilter = () => {
    fetchLeads(filterOptions);
  };

  const handleViewDetails = (lead) => {
    localStorage.setItem("leaddetails", JSON.stringify(lead));
    navigate("/clients/dashboard");
  };



  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert color="danger" variant="soft">
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <FilterHeader
        filterOption={filterOptions}
        onDateChange={handleDateChange}
        onProjectChange={handleProjectChange}
        onFilter={handleFilter}
        projects={projects}
        setLeads={setLeads}
      />

      <div className="space-y-4">
        {isLoading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-pulse text-gray-500">Loading leads...</div>
          </div>
        ) : leads.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No leads found for the selected filters
          </div>
        ) : (
          leads.map((lead) => (
            <LeadCard
              key={lead.id}
              lead={lead}
              onViewDetails={() => handleViewDetails(lead)}
              agentlist={agentlist}
              assignedagent={lead.agent_id}
            />
          ))
        )}
      </div>

      {/* <Alert
        color={snackbarSeverity}
        variant="soft"
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        sx={{
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          minWidth: "300px",
        }}
      >
        {snackbarMessage}
      </Alert> */}
    </Container>
  );
};

export default LeadsListPage;
